import { z } from 'zod';

import { type ValidationMessageSet } from '../../form-validations';
import { getCaptchaTokenSchema } from '../../schemas/captcha-token-schema';
import { getEmailSchema } from '../../schemas/email-schema';
import {
  type NameValidationMessages,
  getNameSchema,
} from '../../schemas/name-schema';
import { getPhoneSchema } from '../../schemas/phone-schema';

type Messages = {
  emailValidationMessages: ValidationMessageSet;
  errorMessage: string;
  firstNameValidationMessages: NameValidationMessages;
  lastNameValidationMessages: NameValidationMessages;
  phoneInvalidMessage: string;
  phoneRequiredMessage: string;
  withPhone?: boolean;
};

// Validation for client form only
export const getFinancingSchema = (messages: Messages) =>
  z
    .object({
      newsletter: z.boolean(),
      phone: getPhoneSchema(messages, { isInputActive: messages.withPhone }),
    })
    .merge(getCaptchaTokenSchema({ requiredMessage: messages.errorMessage }))
    .merge(getEmailSchema(messages.emailValidationMessages))
    .merge(
      getNameSchema(
        messages.firstNameValidationMessages,
        messages.lastNameValidationMessages
      )
    )
    .required();
